import { atom } from 'recoil';

const hasUnsavedChangesState = atom({
    key: 'hasUnsavedChanges',
    default: false,
});

export default hasUnsavedChangesState;
